import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { a as ChildBox } from './Tile.styles-htzhYIpE.js';
import { u as useTileContext } from './TileContext-CQYBPDL3.js';

const TileBox = ({
  hideStartBorder,
  ...restProps
}) => {
  const {
    direction
  } = useTileContext();
  return /*#__PURE__*/React__default.createElement(ChildBox, _extends({}, restProps, {
    $hideStartBorder: hideStartBorder,
    $direction: direction
  }));
};

export { TileBox as T };
//# sourceMappingURL=TileBox-NVB2F86r.js.map
